<template>
  <div class="datacandy-two-metrics text-center">
    <b-row>
      <b-col class="title text-secondary pb-2">
        {{ title }}
      </b-col>
    </b-row>
    <b-row v-if="!is_delta">
      <b-col>
        <b-row>
          <b-col class="metric first">
            {{ numeral(data[0]).format(format) }}
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <small class="text-muted">{{ labels[0] }}</small>
          </b-col>
        </b-row>
      </b-col>
      <b-col>
        <b-row>
          <b-col class="metric second">
            {{ numeral(data[1]).format(format) }}
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <small class="text-muted">{{ labels[1] }}</small>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row v-if="is_delta">
      <b-col class="metric first">
        <b-row>
          <b-col>
            <span v-if="data[0] > 0">
              <i class="fa fa-fw fa-chevron-up"></i>
              {{ numeral(data[0]).format(format)}}
            </span>
            <span class="text-danger" v-if="data[0] < 0">
              <i class="fa fa-fw fa-chevron-down"></i>
              {{ numeral(Math.abs(data[0])).format(format)}}
            </span>
            <span class="text-muted" v-if="!data[0]">
              -
            </span>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <small class="text-muted">{{ labels[0] }}</small>
          </b-col>
        </b-row>
      </b-col>
      <b-col class="metric second">
        <b-row>
          <b-col>
            <span v-if="data[1] > 0">
              <i class="fa fa-fw fa-chevron-up"></i>
              {{ numeral(data[1]).format(format)}}
            </span>
            <span class="text-danger" v-if="data[1] < 0">
              <i class="fa fa-fw fa-chevron-down"></i>
              {{ numeral(Math.abs(data[1])).format(format)}}
            </span>
            <span class="text-muted" v-if="!data[1]">
              -
            </span>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <small class="text-muted">{{ labels[1] }}</small>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  export default {
    props: {
      title: {type: String, default: 'Label'},
      labels: {type: Array, default: ['A', 'B']},
      data: {type: Array, default: [50, 50]},
      format: {type: String, default: '0,000'},
      is_delta: {type: Boolean, default: false},
    },
    data() {
      return {
        trans: trans,
        numeral: numeral,
      }
    },
    methods: {
    },
  }
</script>